<h2 mat-dialog-title>
  {{ 'GlobalSearch.TankSearchResultsTitle' | translate }}
</h2>

<mat-dialog-content class="tank-search-results-content">
  <table mat-table [dataSource]="dataSource" class="tank-results-table" aria-label="Tank search results">
      <!-- Add IsAffiliatedTank "*" if is-->
      <ng-container matColumnDef="affiliated">
        <th mat-header-cell *matHeaderCellDef aria-label="Affiliated status"></th>
        <td mat-cell *matCellDef="let tank">
          <mat-icon *ngIf="tank.isAffiliatedTank === 1" class="affiliated-icon">star</mat-icon>
        </td>
      </ng-container>

      <!-- Tank Name -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GlobalSearch.TankName' | translate }}
        </th>
        <td mat-cell *matCellDef="let tank">
          <ng-container *ngTemplateOutlet="tankLinkTemplate; context: { uniqueId: tank.uniqueId, tab: 'details', linkText: tank.tankName }"></ng-container>
        </td>
      </ng-container>

      <!-- Organization  -->
      <ng-container matColumnDef="organization">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GlobalSearch.OrganizationName' | translate }}
        </th>
        <td mat-cell *matCellDef="let tank">{{ tank.organizationName }}</td>
      </ng-container>


      <!-- location -->
      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GlobalSearch.LocationName' | translate }}
        </th>
        <td mat-cell *matCellDef="let tank">
          <ng-container *ngIf="canViewLocation; else plainLocation">
            <a [routerLink]="['/location', tank.locationId, 'details']" target="_blank" rel="noopener noreferrer">{{ tank.locationName }}</a>
          </ng-container>
          <ng-template #plainLocation>{{ tank.locationName }}</ng-template>
        </td>
      </ng-container>

      <!-- Tank Count -->
      <ng-container matColumnDef="locationTankCount">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GlobalSearch.TankCount' | translate }}
        </th>
        <td mat-cell *matCellDef="let tank">{{ tank.locationTankCount ?? '-' }}</td>
      </ng-container>

      <!-- RTU Number -->
      <ng-container matColumnDef="tanknumber">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GlobalSearch.RtuNumber' | translate }}
        </th>
        <td mat-cell *matCellDef="let tank">
          <ng-container *ngTemplateOutlet="tankLinkTemplate; context: { uniqueId: tank.uniqueId, tab: 'setup', linkText: tank.rtunumber }"></ng-container>
        </td>
      </ng-container>

      <!-- Tank Number -->
      <ng-container matColumnDef="deviceTankNumber">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GlobalSearch.TankNumber' | translate }}
        </th>
        <td mat-cell *matCellDef="let tank">{{ tank.deviceTankNumber ?? '-' }}</td>
      </ng-container>

      <!-- Product -->
      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GlobalSearch.Product' | translate }}
        </th>
        <td mat-cell *matCellDef="let tank">{{ tank.prodDesc }}</td>
      </ng-container>

      <!-- Min Number -->
      <ng-container matColumnDef="minnumber">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GlobalSearch.Min0' | translate }}
        </th>
        <td mat-cell *matCellDef="let tank">{{ tank.min0 }}</td>
      </ng-container>

      <!-- Active -->
      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GlobalSearch.Active' | translate }}
        </th>
        <td mat-cell *matCellDef="let tank">
          <mat-checkbox [disabled]="true" 
                       [checked]="tank.active"
                       aria-label="Active status"></mat-checkbox>
        </td>
      </ng-container>

      <!-- Replica -->
      <ng-container matColumnDef="replica">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GlobalSearch.Replica' | translate }}
        </th>
        <td mat-cell *matCellDef="let tank">
          <mat-checkbox [disabled]="true" 
                       [checked]="tank.isReplica"
                       aria-label="Replica status"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="skytankGatewayRtu">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GlobalSearch.SkyTankGatewayRtu' | translate }}
        </th>
        <td mat-cell *matCellDef="let tank">
          <ng-container *ngIf="isSkyTankAssociatedRow(tank)">
            <ng-container *ngIf="tank.gatewayRTUNumber; else hyphenTemplate">
              <ng-container *ngTemplateOutlet="tankLinkTemplate; context: { uniqueId: (tank.gatewayTankId * 10), tab: 'details', linkText: tank.gatewayRTUNumber}"></ng-container>
            </ng-container>
            
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="lastInventoryTime">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GlobalSearch.LastInventoryTime' | translate }}
        </th>
        <td mat-cell *matCellDef="let tank">
          {{ tank.localizedInvTime }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{ 'GlobalSearch.Actions' | translate }}</th>
        <td mat-cell *matCellDef="let tank" class="actions-cell">
          <app-unassign-tank-button
            *ngIf="canShowAction(tank)"
            [tankId]="tank.tankId"
            [deviceCategory]="tank.deviceTypeCategoryId"
            (unassignComplete)="onUnassignComplete($event)">
          </app-unassign-tank-button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnDefs"></tr>
      <tr mat-row *matRowDef="let row; columns: columnDefs"></tr>
    </table>
</mat-dialog-content>

<mat-dialog-actions>
  <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                 showFirstLastButtons
                 aria-label="Select page of tank results">
  </mat-paginator>
</mat-dialog-actions>


<ng-template #tankLinkTemplate let-uniqueId="uniqueId" let-tab="tab" let-linkText="linkText">
  <a [routerLink]="['tank', uniqueId, tab]"
     [queryParams]="tab === 'setup' ? { t: 'telemetry', src: 'gts' } : { src: 'gts' }"
     (click)="closeDialog()">{{ linkText }}</a>
</ng-template>

<ng-template #hyphenTemplate>-</ng-template>